import buildCustomSelect from './contact/_custom-select'
import buildSwitchCustomSelectPanel from './contact/switchCustomSelectPage'
import translatePagePos from './contact/translatePagePos';

(() => {
  buildCustomSelect();
  buildSwitchCustomSelectPanel();
  translatePagePos();
})()
